module.exports = __webpack_public_path__ + "static/img/标准投教服务图标.d37ab12.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/标准投教服务图标.gif
// module id = wkjf
// module chunks = 3